import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  Link,
  Popover,
  Skeleton,
  debounce,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AppButton from "../../../../../AppComponents/AppButton";
import { AppMaterialIcons } from "../../../../../AppComponents/AppMaterialIcons";
import { withLoader } from "../../../../../AppComponents/Loader";
import useModal from "../../../../../Hooks/useModel/useModel";
import { useNotification } from "../../../../../Hooks/useNotification/useNotification";
import { ConversationService } from "../../../../../Services/Apis/ConversationService";
import { useAppDispatch, useAppSelector } from "../../../../../Store";
import { useCurrentBot } from "../../../../../Store/Slices/DashboardSlices";
import { FaqUserQueryAction } from "../../../../../Store/Slices/Faq/UserQueries/userquery.actions";
import {
  AnsweredFaqQuestionOptionData,
  AnsweredFlowOptionData,
  AnsweredListing,
  answeredListingCount,
  pagesCount,
} from "../../../../../Store/Slices/Faq/UserQueries/userquery.selectors";
import { formatString } from "../../../../../Utils";
import { ReactComponent as SearchIcon } from "../../../../../assets/images/Searchicon.svg";
import { ReactComponent as ModifyIcon } from "../../../../../assets/images/modify.svg";
import nodata from "../../../../../assets/images/noDatafound.svg";
import { ReactComponent as QueryIcon } from "../../../../../assets/images/query.svg";
import { ReactComponent as FilterIcon } from "../../../../../assets/images/unfilterd.svg";
import {
  AppPagination,
  FaqTextWrap,
  Scroll,
  StyledAppInput,
  UploadPopupWrap,
} from "../../BotKnowledgeStyles";
import {
  resetAnsweredListing,
  updateUserInput,
} from "../../../../../Store/Slices/Faq/UserQueries/userquery.slice";
import AnsNotAnsModal from "../../Faq/commonComponents/AnsNotAnsModal";
import SkeletonLoader from "../../../../../AppComponents/Loader/SkeletonLoader";
// import AddFaqsModal from "../commonComponent/AddFaqsModal";
import { AnsweredFaqList, PopOverText } from "./AnsweredFaqStyle";
import AppModel from "../../../../../Hooks/useModel/AppModel";
import { theme } from "../../../../../Customization/Theme";
import AppPaginationComponent from "../../../../../AppComponents/Pagination/Pagination";

interface Props {
  // setLoading(arg0: boolean): unknown;
}

const AnsweredFaq: React.FC<Props> = (props) => {
  // hooks ******
  let { showAlert } = useNotification();
  let dispatch = useAppDispatch();
  const navigate = useNavigate();
  const currentBot = useSelector(useCurrentBot);

  const headers = {
    appid: JSON.stringify({
      botid: currentBot.bot_id,
      // botid: "2f50db4c-ed70-4cc1-b76f-f33c41cc776e",
    }),
  };

  // list data*****
  let answeredListData = useAppSelector(AnsweredListing);
  let answeredDataListCount = useAppSelector(answeredListingCount);
  const totalPages = useAppSelector(pagesCount);

  // options data
  // flow drop-down  data
  const [flowJourney, setFlowJourney] = useState<any>({});
  let FlowData = useAppSelector(AnsweredFlowOptionData);
  // flow drop-down  data
  let FaqQuestion = useAppSelector(AnsweredFaqQuestionOptionData);
  // states
  const [faqQuestionId, setFaqQuestionId] = useState("");
  const [text, setText] = useState<string>("");
  const [selectedItem, setSelectedItem] = useState<any>({
    question: "",
    faqQuestionId: "",
  });

  const [loading, setLoading] = useState<boolean>(false);

  // Popover Functions
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const [radioCheck, setRadioCheck] = useState("first");
  // Setting Values Locally
  const [localValues, setLocalValues] = useState<any>({
    itemsPerPage: { label: "50  per page", value: 50 },
    currentPage: 0,
    question: "",
    checkbox: [],
    checkboxAll: false,
    query: "",
    sort: true,
  });

  // Setting Initial Values For Form
  const [userInput, setUserInput] = useState<any>({
    question: "",
    faqQuestionId: "",
    response: [],
    phrases: [],
    journey: null,
    text: "",
    media: {
      file: { url: "" },
      image: { url: "" },
      video: { url: "" },
    },
  });

  // api call to get answered list
  const getAnsweredList = () => {
    setLoading(true);
    dispatch(resetAnsweredListing({}));
    const data: any = {
      headers,
      offset: localValues.currentPage,
      limit: localValues.itemsPerPage?.value,
      query: localValues.query,
      sort: localValues.sort,
      No: localValues.No,
      Yes: localValues.Yes,
      smartAiAnswer: localValues.smartAiAnswer,
      faqDatabase: localValues.faqDatabase,
    };
    setTimeout(() => {
      dispatch(FaqUserQueryAction.GeteAnsweredListing(data))
        .then((res: any) => {
          setLoading(false);
        })
        .catch((error: any) => {
          showAlert(
            error?.response?.statusText || "Enabled to fetch Data",
            "error"
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }, 1000);
  };

  // api call to get answered faq flow data
  const getAnsweredFaqFlowData = () => {
    setTimeout(() => {
      dispatch(FaqUserQueryAction.GeteAnsweredFlowOptions(headers))
        .then((res: any) => {})
        .catch((error: any) => {
          showAlert(
            error?.response?.statusText || "Enabled to fetch Data",
            "error"
          );
        })
        .finally(() => {});
    }, 1000);
    setTimeout(() => {
      dispatch(FaqUserQueryAction.GeteAnsweredFaqQuestionOption(headers))
        .then((res: any) => {})
        .catch((error: any) => {
          showAlert(
            error?.response?.statusText || "Enabled to fetch Data",
            "error"
          );
        })
        .finally(() => {});
    }, 1000);
  };

  //   Add urls API Call
  const handleSubmitBtn = (values: any, SubmitProps: any) => {
    // validation ****************
    if (radioCheck === "second") {
      if (!values?.journey) {
        SubmitProps.setFieldError(
          "journey",
          "value required in selected field"
        );
        SubmitProps?.setSubmitting(false);
        return;
      }
    } else {
      if (
        !values?.text ||
        values?.text === "<p></p>\n" ||
        values?.text === "<p></p>↵"
      ) {
        SubmitProps.setFieldError("text", "value required in selected field");
        SubmitProps?.setSubmitting(false);
        return;
      }
    }
    const mappedItems = FlowData?.find(
      (item: any) => values.journey === item?.qid
    );

    let newValues;
    if (values?.journey && radioCheck === "second") {
      newValues = {
        ...values,
        journey: mappedItems,
        response_or_flow: "second",
      };
    } else {
      newValues = {
        ...values,
        journey: undefined,
        response_or_flow: "Add Response",
      };
    }
    dispatch(updateUserInput(newValues));
    // add to variation
    if (faqQuestionId) {
      const headers = {
        appid: JSON.stringify({
          botid: currentBot.bot_id,
        }),
      };
      ConversationService.postNotAnsweredFaqsQuestion(
        {
          qid: faqQuestionId,
          query: selectedItem.question,
          conversation_id: selectedItem.conversation_id,
        },
        headers
      ).then(
        (data: any) => {
          SubmitProps.setSubmitting(false);
          SubmitProps.resetForm();
          showAlert("Variation added to list", "success");
          if (data) {
            let url = formatString(
              "/bot/{0}/setup/bot-knowledge/faqs/faq-answer/{1}",
              [currentBot.bot_id, faqQuestionId]
            );
            navigate(url);
          }
        },
        (err: any) => {}
      );
    } else {
      const headers = {
        appid: JSON.stringify({
          botid: currentBot.bot_id,
        }),
      };
      const conversation_id = selectedItem.conversation_id;
      const data = {
        headers,
        conversation_id,
      };
      dispatch(FaqUserQueryAction.RemoveNotAnsConversationByIds(data)).then(
        (res) => {}
      );
      // add new ******
      handleRedirect();
    }
  };

  // redirect
  const handleRedirect = () => {
    let url = formatString("/bot/{0}/setup/bot-knowledge/faqs/faq-answer", [
      currentBot.bot_id,
    ]);
    navigate(url);
  };
  const getEditModalData = (row: any) => {
    toggleModalEdit(); //modal
    setSelectedItem({
      ...row,
      faqQuestionId: "",
    }); //state  update
    getAnsweredFaqFlowData(); //api call

    setUserInput((prev: any) => ({
      ...prev,
      question: row?.question,
      text: row?.response?.[0]?.value,
    }));
  };
  // render list data*************

  useEffect(() => {
    getAnsweredList();
  }, [localValues]);

  useEffect(() => {
    if (faqQuestionId) {
      const mappedItems = FaqQuestion?.find(
        (item: any) => faqQuestionId === item?.qid
      );
      if (mappedItems?.journey && mappedItems?.journey?.qid.length) {
        setRadioCheck("second");
        setUserInput({
          ...userInput,
          journey: mappedItems?.journey?.qid,
        });
        setFlowJourney(mappedItems?.journey);
      } else {
        setRadioCheck("first");
        setAlreadyValuesFn(mappedItems);
      }
    }
  }, [faqQuestionId]);

  const setAlreadyValuesFn = (
    data: any,
    getPhrasesData?: any,
    key?: string
  ) => {
    let text = "";

    let video: any = {
      url: "",
    };
    let file: any = {
      url: "",
    };
    let image: any = {
      url: "",
    };

    let question = selectedItem?.question;
    let journey = data?.journey;
    let phrases = data?.["phrases"] || [];

    data &&
      data?.["response"]?.length > 0 &&
      data?.["response"]?.map((curElem: any, index: number) => {
        if (curElem?.type === "text") {
          text = curElem?.value || "";
        }
        if (curElem.type === "video") {
          video["url"] = curElem?.value?.url || "";
        }
        if (curElem.type === "file") {
          file["url"] = curElem?.value?.url || "";
        }
        if (curElem.type === "image") {
          image["url"] = curElem?.value?.url || "";
        }
        if (curElem.type === "live_agent") {
          // setValue(3);
        }
      });

    let media = {
      file: file,
      video: video,
      image: image,
    };

    setUserInput({
      ...userInput,
      faqQuestionId: data?.qid,
      question: question,
      journey: journey?.qid || null,
      phrases: phrases,
      text: text || "",
      media: media,
    });
  };

  // Edit Modal
  const useModalEdit = () => {
    const { isShowing, toggle } = useModal();
    return { isShowingModalEdit: isShowing, toggleModalEdit: toggle };
  };
  const { isShowingModalEdit, toggleModalEdit } = useModalEdit();

  const useModalText = () => {
    const { isShowing, toggle } = useModal();
    return { isShowingModalText: isShowing, toggleModalText: toggle };
  };
  const { isShowingModalText, toggleModalText } = useModalText();

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // Hadnling Search Functionality
  const handleSelectSearch = debounce((e?: any) => {
    setLocalValues({
      ...localValues,
      query: e.target.value,
      currentPage: 0,
    });
  }, 700);

  // handle toggel radio button
  const handleRadioChange = (event: any) => {
    setRadioCheck(event.target.value);
    setFaqQuestionId("");
    setUserInput({
      ...userInput,
      journey: null,
      faqQuestionId: null,
      text: "",
      media: {
        file: { url: "" },
        image: { url: "" },
        video: { url: "" },
      },
    });
  };

  const [checkboxValues, setCheckboxValues] = useState({
    Yes: false,
    No: false,
    smartAiAnswer: false,
    faqDatabase: false,
  });

  const handleCheckboxChange = (event: any) => {
    const { name, checked } = event.target;
    setCheckboxValues((prevValues) => ({
      ...prevValues,
      [name]: checked,
    }));
  };

  // Handle Pagination Functions
  const handlePageChange = (event: any, value: any) => {
    setLocalValues({
      ...localValues,
      currentPage: value - 1,
    });
  };
  const handleChangeRowsPerPage = (value: any) => {
    setLocalValues({
      ...localValues,
      itemsPerPage: value,
      currentPage: 0,
    });
  };
  // onClose modale reset
  const onCloseResetValues = () => {
    setUserInput({});
    setSelectedItem({});
    setFaqQuestionId("");
    setRadioCheck("first");
  };

  // filter dropDown ******
  const ApplyFilter = (type: any) => {
    // on apply ************
    if (type === "apply") {
      setLocalValues({
        ...localValues,
        Yes: checkboxValues.Yes,
        No: checkboxValues.No,
        smartAiAnswer: checkboxValues["smartAiAnswer"],
        faqDatabase: checkboxValues["faqDatabase"],
      });
    } else {
      // on reset*********
      setLocalValues({
        ...localValues,
        Yes: false,
        No: false,
        smartAiAnswer: false,
        faqDatabase: false,
      });
      setCheckboxValues({
        Yes: false,
        No: false,
        smartAiAnswer: false,
        faqDatabase: false,
      });
    }
    handleClose();
  };

  const ConvertHtmlTaginText = (text: string) => {
    if (text === undefined) {
      return null; // Return null or any other appropriate fallback if text is undefined
    }

    const maxLength = 120; // Set the maximum length for displaying without "Read More"

    if (text?.length <= maxLength) {
      return <div dangerouslySetInnerHTML={{ __html: text }} />;
    } else {
      const truncatedText = text?.slice(0, maxLength);
      return (
        <Box display="">
          <div dangerouslySetInnerHTML={{ __html: truncatedText + "..." }} />

          <div
            onClick={() => {
              setText(text);
              toggleModalText();
            }}
          >
            <Link component="button" underline="none">
              Read More
            </Link>
          </div>
        </Box>
      );
    }
  };

  let texttt = `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`;

  return (
    <>
      <FaqTextWrap>
        <div className="top-header" style={{ justifyContent: "space-between" }}>
          <div className="header-left">
            <p>
              Review and analyze the user queries that received responses from
              the bot, in order to improve and enrich the overall user
              experience.
            </p>
          </div>
          <div className="serach-class" style={{ alignItems: "center" }}>
            <div className="faq-search">
              <StyledAppInput>
                <input
                  type="text"
                  onChange={(e: any) => handleSelectSearch(e)}
                  name="query"
                  id="query"
                  placeholder="Search"
                />
                <SearchIcon />
              </StyledAppInput>
            </div>
            <div className="button">
              <IconButton aria-describedby={id} onClick={handleClick}>
                <FilterIcon />
              </IconButton>
            </div>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <PopOverText>
                <div className="faq-filter">
                  <div className="filter-header">
                    <p>Added to FAQ</p>
                  </div>
                  <ul>
                    <li>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxValues.Yes}
                            onChange={handleCheckboxChange}
                          />
                        }
                        label="Yes"
                        name="Yes"
                      />
                    </li>
                    <li>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxValues.No}
                            onChange={handleCheckboxChange}
                          />
                        }
                        label="No"
                        name="No"
                      />
                    </li>
                  </ul>
                  <div className="filter-header">
                    <p>Answers source</p>
                  </div>
                  <ul style={{ borderBottom: "1px solid #7E83921A" }}>
                    <li>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxValues["smartAiAnswer"]}
                            onChange={handleCheckboxChange}
                          />
                        }
                        label="Smart ai answers"
                        name="smartAiAnswer"
                      />
                    </li>
                    <li>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxValues["faqDatabase"]}
                            onChange={handleCheckboxChange}
                          />
                        }
                        label="FAQ database"
                        name="faqDatabase"
                      />
                    </li>
                  </ul>
                  <div className="button">
                    <AppButton
                      variant="grey"
                      onClick={(e: any) => {
                        ApplyFilter("reset");
                      }}
                    >
                      Reset
                    </AppButton>
                    <AppButton
                      onClick={(e: any) => {
                        ApplyFilter("apply");
                      }}
                    >
                      <AppMaterialIcons iconName="CheckCircleOutlineOutlined" />
                      Apply
                    </AppButton>
                  </div>
                </div>
              </PopOverText>
            </Popover>
          </div>
        </div>

        {/* {/* --------------no data image------------- */}

        {!answeredListData || answeredListData?.length === 0 ? (
          !loading ? (
            <div className="front-image">
              <div className="no-data-img">
                <img src={nodata} alt="Description about" />
              </div>
              <div className="front-text">No Data found</div>
            </div>
          ) : (
            <SkeletonLoader numberOfCol={6} numberofRow={5} />
          )
        ) : (
          <Scroll>
            <AnsweredFaqList>
              <div className="table-header">
                {/* <div className="col-head">Sr.No</div> */}
                <div className="col-head">
                  Queries
                  <IconButton
                    style={{ paddingLeft: "1rem" }}
                    onClick={() =>
                      setLocalValues({
                        ...localValues,
                        sort: localValues.sort ? false : true,
                      })
                    }
                  >
                    {localValues.sort ? (
                      <QueryIcon />
                    ) : (
                      <QueryIcon style={{ transform: "scale(-1)" }} />
                    )}
                  </IconButton>
                </div>
                <div className="col-head">Answers</div>
                <div className="col-head">Frequency</div>
                <div className="col-head">Asked on</div>
                <div className="col-head">Added to FAQ</div>
                <div className="col-head">Answers source</div>
                <div className="col-head"></div>
              </div>
              <div className="table-body">
                {/* Map over the table data */}
                {answeredListData?.map((row: any, index: any) => (
                  <div className="table-row" key={index}>
                    {/* <div className="col-body">{index + 1}</div> */}
                    <div className="col-body queries-column">
                      <div className="query1">
                        {row?.question?.value || row?.question || ""}
                      </div>
                      <div className="query2" style={{ width: "fit-content" }}>
                        {row?.triggered_faq_phrase || ""}
                      </div>
                      <div className="query3">
                        {row?.question?.value || row?.question || ""}
                      </div>
                    </div>
                    <div className="col-body">
                      {ConvertHtmlTaginText(row?.response?.[0]?.value)}
                    </div>{" "}
                    <div className="col-body">{row?.frequency || ""}</div>
                    <div className="col-body">
                      {moment(row?.createdAt).format("DD-MM-YYYY h:mm A")}
                    </div>
                    <div className="col-body">{row?.addedToFaq || ""}</div>
                    <div className="col-body">{row?.answer_source || ""}</div>
                    <div className="col-body">
                      {row?.answer_source !== "FAQ Database" && (
                        <IconButton
                          onClick={() => {
                            getEditModalData(row);
                          }}
                        >
                          <ModifyIcon />
                        </IconButton>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </AnsweredFaqList>
          </Scroll>
        )}

        <AnsNotAnsModal
          isShowingModalEdit={isShowingModalEdit}
          toggleModalEdit={toggleModalEdit}
          onCloseResetValues={onCloseResetValues}
          userInput={userInput}
          handleSubmitBtn={handleSubmitBtn}
          radioCheck={radioCheck}
          handleRadioChange={handleRadioChange}
          FlowData={FlowData}
          FaqQuestion={FaqQuestion}
          setSelectedItem={setSelectedItem}
          setFaqQuestionId={setFaqQuestionId}
          selectedItem={selectedItem}
          faqQuestionId={faqQuestionId}
          type="Answered"
        />
      </FaqTextWrap>
      {/* pagination */}
      {answeredListData?.length ? (
        <AppPaginationComponent
          component="div"
          handlePageChange={handlePageChange}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          currentPage={localValues?.currentPage}
          totalCount={answeredDataListCount}
          totalPages={totalPages}
          rowsPerPage={localValues?.itemsPerPage}
        />
      ) : null}

      {/* Rendering Modal For Text */}
      <AppModel
        isShowing={isShowingModalText}
        divStyle={{
          padding: 0,
        }}
        PaperProps={{
          style: {
            boxShadow: "none",
            width: "786px",
          },
        }}
      >
        <UploadPopupWrap>
          <div
            className="crawl-popup"
            style={{
              borderBottom: `1px solid ${theme.palette.default.lightGrey}`,
              height: "73px",
            }}
          >
            <div className="crawl-heading">
              <p>Answer</p>
            </div>
            <div className="close-icon">
              <IconButton
                onClick={() => {
                  toggleModalText();
                  setText("");
                }}
              >
                <AppMaterialIcons iconName="Close" />
              </IconButton>
            </div>
          </div>
          <Box
            sx={{
              padding: "16px 22px",
              height: "calc(100vh - 550px)",
              overflow: "overlay",
              marginRight: "8px",
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: text }} />
          </Box>
          <Box
            display="flex"
            justifyContent="flex-end"
            sx={{
              padding: "16px 22px",
              borderTop: `1px solid ${theme.palette.default.lightGrey}`,
              height: "73px",
            }}
          >
            <AppButton
              onClick={() => {
                toggleModalText();
                setText("");
              }}
              variant="grey"
            >
              Cancel
            </AppButton>
          </Box>
        </UploadPopupWrap>
      </AppModel>
    </>
  );
};
export default AnsweredFaq;
